import { render } from "./Boletos.vue?vue&type=template&id=1100521e&scoped=true"
import script from "./Boletos.vue?vue&type=script&lang=js"
export * from "./Boletos.vue?vue&type=script&lang=js"

import "./Boletos.vue?vue&type=style&index=0&id=1100521e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1100521e"]])

export default __exports__